import CustomInputField from "./CustomInputField";
import { DateTime } from "luxon";

type Props = {
  label?: string;
  date?: DateTime;
  disabled?: boolean;
  onChanged?: (val: DateTime) => void;
};

function CustomTimePicker(props: Props) {
  function onChanged(val: string) {
    if (props.onChanged) {
      const vals = val.split(":");

      const _original = props.date ?? DateTime.now();
      const data = {
        m: parseInt(vals[1]),
        h: parseInt(vals[0]),
      };
      let _new = _original;
      _new = _new?.set({
        hour: data.h,
        minute: data.m,
      });

      props.onChanged(_new);
    }
  }

  return (
    <CustomInputField
      disabled={props.disabled}
      type={"time"}
      label={props.label}
      value={
        props.date
          ? `${props.date.hour.toString().padStart(2, "0")}:${props.date.minute
              .toString()
              .padStart(2, "0")}`
          : undefined
      }
      onChange={(e) => {
        onChanged(e.target.value);
      }}
    />
  );
}

export default CustomTimePicker;
